import {
   ApiObterFuncionarios,
   ApiObterPatios,   
   ApiObterAtividades,
   ApiObterAtividadesDetalhes,
   ApiObterAtividadesTipo,
   ApiObterReferencias,
   ApiRegistrarAtividade,
   ApiObterEscala,
   ApiObterFuncionariosFiltro,
   ApiObterAtividadePorId,
   ApiEditarAtividade,
   ApiDesconsiderarAtividade
} from '@/api'
import {
   EDITAR_ATIVIDADE,
   INCLUIR_ATIVIDADE,
   OBTER_ATIVIDADES,
   OBTER_ATIVIDADES_DETALHES,
   OBTER_ATIVIDADES_TIPO,
   OBTER_ATIVIDADE_POR_ID,
   OBTER_ESCALA,
   OBTER_FUNCIONARIOS,
   OBTER_FUNCIONARIOS_FILTRO,
   OBTER_PATIO,   
   OBTER_REFERENCIAS
} from './mutations-types'

export const ActionObterFuncionarios = async ({ commit }, filtros) =>
   await ApiObterFuncionarios(filtros)
      .then((response) => commit(OBTER_FUNCIONARIOS, response))
      .catch(() => commit(OBTER_FUNCIONARIOS, null))

export const ActionObterFuncionariosFiltro = ({ commit }, filtros) =>
   ApiObterFuncionariosFiltro(filtros)
      .then((response) => commit(OBTER_FUNCIONARIOS_FILTRO, response))
      .catch(() => commit(OBTER_FUNCIONARIOS_FILTRO, null))

export const ActionObterReferencias = ({ commit }, filtros) =>
   ApiObterReferencias(filtros)
      .then((response) => commit(OBTER_REFERENCIAS, response))
      .catch(() => commit(OBTER_REFERENCIAS, null))

export const ActionObterAtividades = ({ commit }, filtros) =>
   ApiObterAtividades(filtros)
      .then((response) => commit(OBTER_ATIVIDADES, response))
      .catch(() => commit(OBTER_ATIVIDADES, null))

export const ActionObterAtividadesDetalhes = ({ commit }, filtros) =>
   ApiObterAtividadesDetalhes(filtros)
      .then((response) => commit(OBTER_ATIVIDADES_DETALHES, response))
      .catch(() => commit(OBTER_ATIVIDADES_DETALHES, null))

export const ActionObterAtividadesTipo = ({ commit }, filtros) =>
   ApiObterAtividadesTipo(filtros)
      .then((response) => commit(OBTER_ATIVIDADES_TIPO, response))
      .catch(() => commit(OBTER_ATIVIDADES_TIPO, null))

export const ActionObterPatio = ({ commit }, filtros) =>
   ApiObterPatios(filtros)
      .then((response) => commit(OBTER_PATIO, response))
      .catch(() => commit(OBTER_PATIO, null))

export const ActionObterEscala = ({ commit }, idEscala) =>
   ApiObterEscala(idEscala)
      .then((response) => commit(OBTER_ESCALA, response))
      .catch(() => commit(OBTER_ESCALA, null))

export const ActionRegistrarAtividade = ({ commit }, payload) =>
   ApiRegistrarAtividade(payload).then((response) => commit(INCLUIR_ATIVIDADE, response))

export const ActionObterAtividadePorId = ({ commit }, id) =>
   ApiObterAtividadePorId(id)
      .then((response) => commit(OBTER_ATIVIDADE_POR_ID, response))
      .catch(() => commit(OBTER_ATIVIDADE_POR_ID, null))

export const ActionEditarAtividade = ({ commit }, payload) => ApiEditarAtividade(payload).then((response) => commit(EDITAR_ATIVIDADE, response))

export const ActionDesconsiderarAtividade = async ({ commit }, payload) => {
   await ApiDesconsiderarAtividade(payload).then((response) => commit(EDITAR_ATIVIDADE, response))
}
